/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

export const MemberPropTypes = PropTypes.shape({
  name: PropTypes.string,
  email: PropTypes.string,
  isAdmin: PropTypes.bool,
  /** list of the members current roles */
  roles: PropTypes.arrayOf(PropTypes.string),
});

export const MembersPropTypes = PropTypes.arrayOf(MemberPropTypes);

export const RolesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    uid: PropTypes.string,
    defaultName: PropTypes.string,
    nameNlsLabel: PropTypes.string,
  })
);
